import { Directive, ElementRef, EventEmitter, OnDestroy, OnInit, Output, inject } from '@angular/core';

@Directive({
  selector: '[appFormBlurNotifier]',
  exportAs: 'appFormBlurNotifier',
})
export class FormBlurNotifierDirective implements OnInit, OnDestroy {
  private readonly el = inject(ElementRef);

  @Output() formBlurred = new EventEmitter<void>();

  // checks whether the emit should be canceled because there is another event emitting before and then there is no sense notifying the blur
  private actionPending = false;

  private readonly handler: (event: FocusEvent) => void;

  constructor() {
    this.handler = this.handleBlur.bind(this);
  }

  ngOnInit(): void {
    this.el.nativeElement.addEventListener('focusout', this.handler);
  }

  ngOnDestroy(): void {
    this.el.nativeElement.removeEventListener('focusout', this.handler);
  }

  public cancelNextBlur(): void {
    this.actionPending = true;

    // auto-reset
    setTimeout(() => {
      this.actionPending = false;
    }, 100);
  }

  private handleBlur(event: FocusEvent): void {
    // only emits when the focus completely leaves the form or if there is no element receiving focus (null)
    // with this we avoid emit when the user is still entering data.
    if (
      (event.relatedTarget === null || !this.el.nativeElement.contains(event.relatedTarget as Node)) &&
      !this.actionPending
    ) {
      this.formBlurred.emit();
    }
  }
}
